interface selectModelParams {
  linkId: number;
}
// 选择模型页面参数
export const useSelectModelParams = () =>
  useState("selectModelParams", () => <selectModelParams>{});

// 是否展示已导入
export const useShowImported = () => useState("showImported", () => false);
